import React, { ElementType, useContext } from 'react';
import RecorderDrawerContext from '../../Context';
import {
  PreviewComponentProps,
  previews,
} from '~/App/Modules/Settings/MessageTemplates/Pages/Editor/EmailTemplatePreview';
import Email from '~/App/Modules/Settings/MessageTemplates/Pages/Editor/Previews/Email';
import { EmailLayout } from '~/App/Modules/Settings/MessageTemplates/Types';

function renderEmailBody(
  PreviewComponent: React.ElementType,
  props: PreviewComponentProps
) {
  return <PreviewComponent {...props}>{props.message}</PreviewComponent>;
}

export function EmailPreview(props: PreviewComponentProps) {
  const { messageTemplate } = useContext(RecorderDrawerContext);
  const PreviewComponent = previews[
    messageTemplate?.email_template?.layout ?? EmailLayout.Html
  ] as ElementType;

  return (
    <div className='w-full h-full md:w-[775px] md:h-[640px] scale-[0.62]'>
      <Email
        name={props.name}
        image={props.image}
        subject={props.subject}
        body={renderEmailBody(PreviewComponent, props)}
      />
    </div>
  );
}
